.screen {
  padding: 32px 72px;
  display: flex;
  flex-direction: column;
}
.header {
  margin-bottom: 14px;
}
.body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 56px;
  padding-bottom: 96px;
}

.plan {
  position: relative;
  width: 580px;
  height: 380px;
  overflow: hidden;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}
.planDrawing {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.marker {
  position: absolute;
  z-index: 2;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  background: none;
}
.markerRing {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2.5px solid var(--color-neutral-300);
  border-radius: 50%;
  background: var(--color-surface);
  box-shadow: var(--shadow-sm);
  transition:
    border-color 0.15s,
    background 0.15s;
}
.markerDot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--color-neutral-400);
}
.markerLabel {
  font-family: var(--font-heading);
  font-size: 11px;
  font-weight: 700;
  color: var(--color-neutral-600);
  background: var(--color-surface);
  padding: 2px 6px;
  border-radius: 6px;
  white-space: nowrap;
}
.selected .markerRing {
  border-color: var(--color-accent);
  background: var(--color-accent-100);
}
.selected .markerDot {
  background: var(--color-accent);
}
.selected .markerLabel {
  color: var(--color-accent-700);
}

.list {
  width: 280px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.listHeading {
  margin-bottom: 4px;
}
.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 18px;
  background: var(--color-surface);
  border: 2px solid var(--color-divider);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 14px;
  box-shadow: var(--shadow-sm);
  transition: border-color 0.15s;
}
.row:hover {
  background: var(--color-accent-100);
}
.row[aria-pressed='true'] {
  border-color: var(--color-accent);
}
.rowLabel {
  color: var(--color-text);
}
.rowStatus {
  color: var(--color-accent-700);
}
.note {
  margin-top: 6px;
  font-size: 12px;
  color: var(--color-neutral-600);
  font-weight: 600;
  line-height: 1.5;
}

/* — bulb selection — */
.bulbs {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.bulbsHeader {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.bulbsHint {
  font-size: 10px;
  font-weight: 700;
  color: var(--color-neutral-600);
}
.bulbRow {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.bulb {
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--color-surface);
  border: 2px solid var(--color-divider);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 20px;
  color: var(--color-neutral-500);
  box-shadow: var(--shadow-sm);
  transition:
    border-color 0.15s,
    background 0.15s;
}
.bulbDot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid var(--color-neutral-400);
}
.bulb[aria-pressed='true'] {
  border-color: var(--color-accent);
  background: var(--color-accent-100);
  color: var(--color-accent-700);
}
.bulb[aria-pressed='true'] .bulbDot {
  border-color: var(--color-accent);
  background: var(--color-accent);
}

/* — action bar additions — */
.actionMeta {
  margin-top: 2px;
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 14px;
  color: var(--color-neutral-700);
}
.actionRight {
  display: flex;
  align-items: center;
  gap: 24px;
}
.confirm {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 220px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--color-text);
  cursor: pointer;
}
.confirm input {
  flex: none;
  width: 26px;
  height: 26px;
  accent-color: var(--color-accent);
}
